const SvgKillChildren = props => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" {...props}>
    <g fill="none" fillRule="evenodd" stroke="currentColor">
      <path
        d="M9 8.5v-4M9 13.5v-4M15 13.5v-4M3 13.5v-4M3 9h12"
        strokeLinecap="square"
      />
      <rect height={4} rx={1} width={4} x={7} y={0.5} />
      <rect height={4} rx={1} width={4} x={7} y={13.5} />
      <rect height={4} rx={1} width={4} x={13} y={13.5} />
      <rect height={4} rx={1} width={4} x={1} y={13.5} />
    </g>
  </svg>
)

export default SvgKillChildren
